import styles from "../Jobseeker.module.css";

type Props = {
  icon: string;
  title: string;
};

const CategoryCard = ({ icon, title }: Props) => {
  return (
    <div className={styles.categoryCard}>
      <img src={icon} className={styles.categoryIcon} />
      <h3 className={styles.featureTitle}>{title}</h3>
    </div>
  );
};

export default CategoryCard;
